import { createContext, useContext } from 'react';

/** True only inside the offline (no-account) app build, whose entry provides
 *  it. The online app never provides it, so the default is false and online
 *  behavior is unchanged. Same shape as TryModeContext. */
export const OfflineModeContext = createContext<boolean>(false);

export function useIsOfflineApp(): boolean {
    return useContext(OfflineModeContext);
}
